import type { BackgroundColor, MotifScheme } from '@snapchat/snap-design-system-marketing';
import {
  GlobalHeaderContext,
  GlobalNavScreen as GlobalNavScreenSDS,
} from '@snapchat/snap-design-system-marketing';
import type { FC, ReactNode } from 'react';
import { useContext } from 'react';

import type { GlobalNavAllType } from '../../generated/contentful-types';
import type { GlobalNavGroupSummaryClickDetails } from '../GlobalHeader/types';
import { GlobalNavGroupCollection } from '../GlobalNavGroupCollection/GlobalNavGroupCollection';
import { GlobalNavHighlightCollection } from '../GlobalNavHighlightCollection/GlobalNavHighlightCollection';

interface GlobalNavGroupScreenProps {
  motifScheme?: MotifScheme;
  /** @deprecated Use motifScheme instead. */
  backgroundColor?: BackgroundColor;
  localNavMobile: ReactNode;
  localNavMobileFooter?: ReactNode;
  navGroups: readonly GlobalNavAllType[];
  globalNavHeading: string;
  showMobileGlobalLinks?: boolean;
  onGlobalNavGroupSummaryClick?: (details: GlobalNavGroupSummaryClickDetails) => void;
}

export const GlobalNavGroupScreen: FC<GlobalNavGroupScreenProps> = ({
  motifScheme,
  backgroundColor,
  localNavMobile,
  localNavMobileFooter,
  navGroups,
  globalNavHeading,
  showMobileGlobalLinks,
  onGlobalNavGroupSummaryClick,
}) => {
  const { toggleExpanded } = useContext(GlobalHeaderContext);
  const onNavClose = toggleExpanded ?? (() => null);
  return (
    <GlobalNavScreenSDS
      localNavMobile={localNavMobile}
      localNavMobileFooter={localNavMobileFooter}
      onNavClose={onNavClose}
      motifScheme={motifScheme}
      backgroundColor={backgroundColor}
      globalNavHeading={globalNavHeading}
      highlight={<GlobalNavHighlightCollection navGroups={navGroups} />}
      globalNav={
        <GlobalNavGroupCollection
          navGroups={navGroups}
          onGlobalNavGroupSummaryClick={onGlobalNavGroupSummaryClick}
        />
      }
      showMobileGlobalLinks={showMobileGlobalLinks}
    />
  );
};
GlobalNavGroupScreen.displayName = 'GlobalNavGroupScreen';
